import React from "react";
import styled from "styled-components";

import { useNavigate } from "react-router-dom";

import { format } from 'date-fns'

import { SUB_DOMAIN_NAMES } from "data/AdminData"

import { Card, Button, List } from 'semantic-ui-react'
import PropTypes from 'prop-types'

const RowCard = ({ row, get_organization_select }) => {
  const navigate = useNavigate()

  return (
    <>
      <Card fluid key={row?.id}>

        <Card.Content>
          <Card.Header>{row?.first_name}{" "}{row?.last_name}</Card.Header>
          <Card.Meta>{row?.email}{" "}{row?.mobiie}</Card.Meta>
       
          <Container>
            <List horizontal>
             
              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>Name</List.Header>
                   {row?.name}
                </ListContainer>
                  </List.Content>
              </List.Item>
              
              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>Domain</List.Header>
                   {row?.domain && SUB_DOMAIN_NAMES.filter(sy => sy.value === row?.domain)?.[0]?.label}
                </ListContainer>
                  </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>Organization</List.Header>
                   {row?.organization ?
                    get_organization_select.filter(org => org.id === row?.organization)?.[0]?.name:
                    "For all Org"}
                </ListContainer>
                  </List.Content>
              </List.Item>
              
              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>Created</List.Header>
                   {row?.created_at && format(new Date(row?.created_at), 'dd-MMM-yyyy')}
                </ListContainer>
                 
                </List.Content>
              </List.Item>
              <List.Item>
                <List.Content>
                  <ListContainer>
                     <List.Header>Last Updated</List.Header>
                     {row?.updated_at && format(new Date(row?.updated_at), 'dd-MMM-yyyy')}
                  </ListContainer>
                 
                </List.Content>
              </List.Item>
           
            </List>
          </Container>

          <Card.Description>
            
            <Button floated='right'
              onClick={() => navigate(`/app/email-templates/details/${row?.id}`)}>
              More Details
            </Button>
          </Card.Description>
        </Card.Content>

      </Card>
    </>
  );
};

RowCard.propTypes = {
  row: PropTypes.object.isRequired,
};

export default RowCard;


const ListContainer = styled.div`
  margin: 0px 25px;
  // padding: 0px 25px;
  // background-color: #dcdcdcdc;
`


const Container = styled.div`
  display: flex;
  margin: 10px 0;
`

